// Shared event-type color palette (single source of truth).
// Each palette key maps to Tailwind class sets used across the calendar views.
// Keeping the literal class strings here ensures Tailwind JIT includes them.

export const EVENT_COLOR_PALETTE = {
    green: { bg: 'bg-green-100', text: 'text-green-700', dot: 'bg-green-500', hex: '#22c55e', label: 'Grün' },
    blue: { bg: 'bg-blue-100', text: 'text-blue-700', dot: 'bg-blue-500', hex: '#3b82f6', label: 'Blau' },
    purple: { bg: 'bg-purple-100', text: 'text-purple-700', dot: 'bg-purple-500', hex: '#a855f7', label: 'Violett' },
    orange: { bg: 'bg-orange-100', text: 'text-orange-700', dot: 'bg-orange-500', hex: '#f97316', label: 'Orange' },
    amber: { bg: 'bg-amber-100', text: 'text-amber-700', dot: 'bg-amber-500', hex: '#f59e0b', label: 'Bernstein' },
    red: { bg: 'bg-red-100', text: 'text-red-700', dot: 'bg-red-500', hex: '#ef4444', label: 'Rot' },
    rose: { bg: 'bg-rose-100', text: 'text-rose-700', dot: 'bg-rose-500', hex: '#f43f5e', label: 'Rosé' },
    pink: { bg: 'bg-pink-100', text: 'text-pink-700', dot: 'bg-pink-500', hex: '#ec4899', label: 'Pink' },
    indigo: { bg: 'bg-indigo-100', text: 'text-indigo-700', dot: 'bg-indigo-500', hex: '#6366f1', label: 'Indigo' },
    cyan: { bg: 'bg-cyan-100', text: 'text-cyan-700', dot: 'bg-cyan-500', hex: '#06b6d4', label: 'Cyan' },
    teal: { bg: 'bg-teal-100', text: 'text-teal-700', dot: 'bg-teal-500', hex: '#14b8a6', label: 'Türkis' },
    slate: { bg: 'bg-slate-100', text: 'text-slate-700', dot: 'bg-slate-500', hex: '#64748b', label: 'Grau' },
};

// Legacy default color per known type name (fallback when no custom color is configured).
const DEFAULT_BY_TYPE = {
    'Training': 'green',
    'Spiel': 'blue',
    'Fest': 'purple',
    'Turnier': 'orange',
    'Versammlung': 'slate',
    'Geburtstag': 'pink',
    'Dienst': 'amber',
    'Sitzung': 'indigo',
    'Buchung': 'cyan',
    'Fahrt': 'teal',
    'Maßnahme': 'rose',
};

export const defaultEventColorKey = (type) => DEFAULT_BY_TYPE[type] || 'red';

// Resolve the Tailwind class set for a given event type, honoring the admin-configured colorMap.
export const resolveEventColor = (type, colorMap = {}) => {
    const key = (colorMap && colorMap[type]) || defaultEventColorKey(type);
    return EVENT_COLOR_PALETTE[key] || EVENT_COLOR_PALETTE.red;
};
